import { env, G } from '@2l/utils'

const GOOGLE_CLIENT_ID = env(
  'GOOGLE_CLIENT_WEB_ID',
  '787677384866-sbrorj1e4451nnl8g8rdihcfvep54ccb.apps.googleusercontent.com'
)

const ERROR_MESSAGE = 'alert_something_went_wrong'

const getToken = G('access_token')

class Google {
  async authenticate() {
    return new Promise((resolve, reject) => {
      const handleSuccessResponse = (response) => {
        const token = getToken(response)
        if (!token) {
          reject(new Error(ERROR_MESSAGE))
        }
        resolve(token)
      }

      const data = {
        client_id: GOOGLE_CLIENT_ID,
        scope: 'profile',
        callback: handleSuccessResponse,
        error_callback: () => {
          reject(new Error(ERROR_MESSAGE))
        }
      }

      const client = window.google.accounts.oauth2.initTokenClient(data)
      client.requestAccessToken()
    })
  }
}

export default Google
